import { render, staticRenderFns } from "./AssessmentGrid.vue?vue&type=template&id=f2a04f4e"
import script from "./AssessmentGrid.vue?vue&type=script&lang=js"
export * from "./AssessmentGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports